import { filtrSmartCatalogAPI } from "../ApiStore/apiStore";

const SET_FILTER_ITEMS = "SET-FILTER-ITEMS";
const TOGGLE_IS_DISPETCHER = "TOGGLE-IS-DISPETCHER";
const SET_CHECKED_FILTR = "SET-CHECKED-FILTR";
const GET_CHECKED_COUNT_ITEMS = "GET-CHECKED-COUNT-ITEMS";
const GET_URL_FILTR = "GET-URL-FILTR";
const GET_TAG_FILTR = "GET-TAG-FILTR";
const GET_REMOVE_FILTR_ITEMS = "GET-REMOVE-FILTR-ITEMS";
const GET_PRICE_FILTR_SLIDE = "GET-PRICE-FILTR-SLIDE";
const GET_PRICE_FILTR_SLIDE_MAX_MIN = "GET-PRICE-FILTR-SLIDE-MAX-MIN";

let initialState = {
    filterItems: [],
    isFetchingFilter: true,
    checked: [],
    countItems: "",
    getUrlFiltr: "",
    getPriceSlideMaxMin: ["144","28190"],
    getPriceSlide: ["144","28190"],
    tagCloudFiltr: [],
    catalogUrl: "catalog"
}

const filterCatalogReducer = (state = initialState, action) => {

    switch (action.type) {

        case SET_FILTER_ITEMS: {

            return {
                ...state,
                filterItems: action.filterItems
            }
        }
        case TOGGLE_IS_DISPETCHER: {

            return {
                ...state,
                isFetchingFilter: action.isFetchingFilter
            }
        }
        case SET_CHECKED_FILTR: {
            
            return {
                ...state,
                checked: action.checked
            }
        }
        case GET_CHECKED_COUNT_ITEMS: {

            return {
                ...state,
                countItems: action.countItems
            }
        }
        case GET_URL_FILTR: {

            return {
                ...state,
                getUrlFiltr: action.urlFiltr
            }
        }
        case GET_TAG_FILTR: {

            return {
                ...state,
                tagCloudFiltr: action.tagFiltr
            }
        }
        case GET_REMOVE_FILTR_ITEMS: {

            return {
                ...state,
                tagCloudFiltr: action.tagFiltr
            }
        }
        case GET_PRICE_FILTR_SLIDE: {

            return {
                ...state,
                getPriceSlide: action.getPriceSlide
            }
        }
        case GET_PRICE_FILTR_SLIDE_MAX_MIN: {

            return {
                ...state,
                getPriceSlideMaxMin: action.getPriceSlideMaxMin
            }
        }
        default: {
            return state;
        }
    }

}

export const setFiltersAC = (filterItems) => {

    return {
        type: SET_FILTER_ITEMS, filterItems
    }
}
export const settoggleDispetcher = (isFetchingFilter) => {
    return {
        type: TOGGLE_IS_DISPETCHER, isFetchingFilter
    }
}
export const setCheckenFiltr = (checked) => {
    
    return {
        type: SET_CHECKED_FILTR, checked
    }
}
export const getFiltersCountItems = (countItems) => {
    return {
        type: GET_CHECKED_COUNT_ITEMS, countItems
    }
}
export const getPriceFiltrItems = (getPriceSlide) => {
    return {
        type: GET_PRICE_FILTR_SLIDE, getPriceSlide
    }
}
export const getPriceFiltrItemsMaxMin = (getPriceSlideMaxMin) => {
    return {
        type: GET_PRICE_FILTR_SLIDE_MAX_MIN, getPriceSlideMaxMin
    }
}
export const getFiltersUrl = (urlFiltr) => {
    return {
        type: GET_URL_FILTR, urlFiltr
    }
}
export const getFiltersTag = (tagFiltr) => {

    return {
        type: GET_TAG_FILTR, tagFiltr
    }
}
export const getFiltr = () => async (dispatch) => {


    dispatch(settoggleDispetcher(true));
    let data = await filtrSmartCatalogAPI.getProperty();
    dispatch(setFiltersAC(data.VALUEFILTR.SMART_FILTER));
    dispatch(getFiltersCountItems(data.VALUEFILTR.COUNT_SALE));
    dispatch(getPriceFiltrItems(data.VALUEFILTRPRICEREZFILTR));
    dispatch(getPriceFiltrItemsMaxMin(data.VALUEFILTRPRICE));
    dispatch(settoggleDispetcher(false));

}

export const setFiltr = (parametr) => async (dispatch) => {

    dispatch(settoggleDispetcher(true));
    let data = await filtrSmartCatalogAPI.getProperty(parametr);
    dispatch(setFiltersAC(data.VALUEFILTR.SMART_FILTER));
    dispatch(getFiltersCountItems(data.VALUEFILTR.COUNT_SALE));
    dispatch(getPriceFiltrItems(data.VALUEFILTRPRICEREZFILTR));
    dispatch(getPriceFiltrItemsMaxMin(data.VALUEFILTRPRICE));
    dispatch(settoggleDispetcher(false));

}


export default filterCatalogReducer;